import { createReducer, INITIAL_STATE, Type } from 'store/utils';
import { GET_DOCTORS_ACTIONS } from './constants';

export const initialState = {
  get: {
    ...INITIAL_STATE,
    data: [],
    hasMore: true,
    page: 0,
  },
};

const getDoctorsMapper: Type[] = [
  {
    type: GET_DOCTORS_ACTIONS.START,
    mapper: ({ get, ...state }) => ({
      ...state,
      get: {
        ...get,
        loading: true,
      },
    }),
  },
  {
    type: GET_DOCTORS_ACTIONS.FAIL,
    mapper: ({ get, ...state }, { error }) => ({
      ...state,
      get: {
        ...get,
        loading: false,
        loaded: true,
        error,
      },
    }),
  },
  {
    type: GET_DOCTORS_ACTIONS.SUCCESS,
    mapper: ({ get, ...state }, { data }) => {
      return {
        ...state,
        get: {
          ...get,
          loading: false,
          loaded: true,
          error: null,
          data: [...get.data, ...data],
          hasMore: data?.length > 0,
          page: get.page + 1,
        },
      };
    },
  },
  {
    type: GET_DOCTORS_ACTIONS.RESET,
    mapper: ({ get, ...state }) => ({
      ...state,
      get: initialState.get,
    }),
  },
];

export default createReducer({ types: getDoctorsMapper, initialState });
